export default "__VITE_ASSET__DLNJ3dot__"